import { Link } from '@anytag/router';
import { cn } from '@anytag/shared-utils';
import { TabType } from './types';

export interface TabsProps extends React.ComponentProps<'div'> {
  options: TabType[];
  hasIndex?: boolean;
}

export const Tabs = ({ options, className, hasIndex, children, ...restProps }: TabsProps) => (
  <div className={cn('tabs-container', className)} {...restProps}>
    <div className="flex gap-4 self-start text-base font-semibold">
      {options
        .filter((tab) => !tab.hidden)
        .map(({ label, end, to, onClick, disabled, params, search, includeSearch }, index) => (
          <Link
            key={`tab-${index}`}
            to={to}
            params={params}
            search={search}
            className={cn(
              'tab-title',
              'relative h-8 cursor-pointer overflow-hidden px-2 leading-8 text-ellipsis whitespace-nowrap text-secondary',
              '[&.active]:text-primary',
              '[&.active]:before:absolute [&.active]:before:bottom-0 [&.active]:before:left-0 [&.active]:before:h-0.5 [&.active]:before:w-full [&.active]:before:rounded-t-full [&.active]:before:bg-active',
              disabled && 'cursor-default text-black-60'
            )}
            // Avoid reset params when click same path
            activeProps={{ style: { pointerEvents: 'none' }, className: 'active' }}
            activeOptions={{ exact: end, includeSearch: includeSearch ?? false }}
            onClick={(e) => {
              if (disabled) {
                e.preventDefault();
              }

              onClick?.(e);
            }}
          >
            {hasIndex ? `${index + 1}. ${label}` : label}
          </Link>
        ))}
    </div>
    {children}
  </div>
);
